import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/lib/auth-guards'
import { PlansAnalyticsTab } from '@/features/dashboard/tabs/plans-analytics-tab'

export const Route = createFileRoute(
  '/_authenticated/dashboard/plans-analytics'
)({
  beforeLoad: requireSuperAdmin,
  component: PlansAnalyticsTab,
})
